<template lang="pug">
  v-card.rounded-lg.transactions-container.px-5.pb-5(:height="shop ? '100%' : '90%'")
    v-card-title.justify-center.main-title-primary.my-2 Ventas totales
    v-row.mx-auto.table-container
      table.all-width(:style="sales && sales.length > 0 ? '':'height: 10px;'")
        thead
          tr
            th(v-for="head in headers" :class="head.class") {{ head.text}}
        tbody(v-if="sales && sales.length > 0")
          tr.text-center(v-for="sale of sales")
            td {{ sale.location_from ? sale.location_from.name : '' }}
            td {{ sale.total | numberFormat }}
            td {{ sale.time | moment }}
      no-results(v-if="sales && sales.length == 0" title="Aún no tienes ventas")
</template>

<script>
  import moment from 'moment'
  export default {
    components: {
      noResults: () => import('@/components/custom/NoResults.vue'),
    },
    filters: {
      numberFormat (val) {
        if (val) { return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.') }
        return '0 '
      },
      moment: function (date) {
        return moment(date).format('MMMM Do YYYY, h:mm a')
      },
    },
    props: {
      shop: {
        type: String,
        default: null,
      },
    },
    computed: {
      headers () {
        return [
          {
            text: 'Tienda',
            value: 'cash',
            align: 'center',
            width: '33%',
            sortable: false,
            class: 'transactions-headers',
          },
          {
            text: 'Valor',
            value: 'total',
            align: 'center',
            width: '33%',
            sortable: false,
            class: 'transactions-headers',
          },
          {
            text: 'Fecha',
            value: 'time',
            align: 'center',
            width: '33%',
            sortable: false,
            class: 'transactions-headers',
          },
        ]
      },
      sales () {
        const vm = this
        const sales = vm.$store.state.transactions.sales
        if (vm.shop && sales) {
          return sales.filter((el) => {
            if (el.location_from.id === vm.shop) {
              return true
            }
          })
        }
        return sales
      },
    },
    created () {
      this.getTransactions()
    },
    methods: {
      async getTransactions () {
        const vm = this
        const from = moment().startOf('isoWeek').format('YYYY-MM-DD')
        const to = moment().endOf('isoWeek').format('YYYY-MM-DD')
        await vm.$store.dispatch('transactions/loadLog', ['sales', from, to, false, 400])
      },
    },
  }
</script>

<style lang="scss" scoped>
  .transactions-container{
    .all-width{
      width: 100% !important
    }
    .transactions-headers{
      background: #e5f3f4 !important;
      color: #9db7b9 !important;
      font-size: 15px !important;
      font-weight: 200 !important;
      width: 33% !important;
      height: 40px !important;
    }
    .table-container{
      height: 330px;
      width: 100%;
      overflow: scroll;
      overflow-x: hidden;
    }
    .table-container{
      scrollbar-width: none;
    }
    .table-container::-webkit-scrollbar {
      display: none;
    }
  }
</style>
